import { type ExtendShiftConfig, ExtendShiftState } from "@clipboard-health/flag-backend-main";

interface ExtendShiftConfigResult {
  isExtendShiftFeatureEnabled: boolean;
  isShiftExtendable: boolean;
}

export function getExtendShiftConfig(
  extendShiftConfig: ExtendShiftConfig | undefined
): ExtendShiftConfigResult {
  if (!extendShiftConfig || extendShiftConfig.state === ExtendShiftState.DISABLED) {
    return {
      isExtendShiftFeatureEnabled: false,
      isShiftExtendable: false,
    };
  }

  if (extendShiftConfig.state === ExtendShiftState.SHIFT_EXTENSION_DISABLED) {
    return {
      isExtendShiftFeatureEnabled: true,
      isShiftExtendable: false,
    };
  }

  return {
    isExtendShiftFeatureEnabled: true,
    isShiftExtendable: true,
  };
}
